export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_MODE
    : process.env.REACT_APP_PRO_MODE;
export const PICTURE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_MODE?.slice(0, -5)
    : process.env.REACT_APP_PRO_MODE?.slice(0, -5);
export const LOGIN_URL = BASE_URL + "auth";
export const COMPANY_URL = BASE_URL + "admin/companies";
export const USER_URL = BASE_URL + "admin/users";
export const SUBSCRIPTION_URL = BASE_URL + "admin/subscriptions";
export const JOB_TYPE_URL = BASE_URL + "admin/job-types";
export const JOB_CATEGORIES_URL = BASE_URL + "admin/job-categories";
export const JOB_TARGET_GROUPS_URL = BASE_URL + "admin/job-target-groups";
export const SETTINGS_URL = BASE_URL + "admin/settings";
export const BLOG_URL = BASE_URL + "admin/blogs";
export const LOCATION_URL = BASE_URL + "admin/locations";
export const PAGE_URL = BASE_URL + "admin/pages";
export const QA_CATEGORY_URL = BASE_URL + "admin/qa/categories";
export const QA_URL = BASE_URL + "admin/qa";
export const SECTION_URL = BASE_URL + "admin/sections";
export const JOBS_URL = BASE_URL + "admin/jobs";
export const DASHBOARD_URL = BASE_URL + "admin/dashboard";
export const PACKAGES_URL = BASE_URL + "admin/subscriptions/packages";
export const OFFERS_URL = BASE_URL + "admin/offers";
export const OFFER_COACH_DOCUMENTS_URL =
  BASE_URL + "admin/offer-coach-documents";
export const REGIONS_URL = BASE_URL + "admin/regions";
export const QUALIFICATIONS_URL = BASE_URL + "admin/qualifications";
export const JOB_FORMATS_URL = BASE_URL + "admin/job-formats";
export const DECLINE_REASON_URL = BASE_URL + "admin/offer-decline-reasons";
export const PARTNER_URL = BASE_URL + "admin/associations";
export const EMAIL_URL = BASE_URL + "admin/emails";
export const FEEDBACK_URL = BASE_URL + "admin/feedbacks";
export const AUDIT_LOG_URL = BASE_URL + "admin/audit-logs";
